import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { FinancialAccountModel } from 'app/models/financial_account.model';

@Injectable({
    providedIn: 'root',
})
export class FinancialAccountService extends BaseService<FinancialAccountModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'financialAccount');
    }
}
